<template>
  <c-modal-form
    :id="$getConst('DOCUMENTS_ORDER_MODAL_ID')"
    :submit-btn="false"
    :fields-required="false"
    :logo-top="false"
    :loading="sending"
    :error="error"
    title="Вы действительно хотите заказать акт сверки?"
  >
    <demo-denied />

    <form>
      <button
        class="btn background-white border-danger text-danger margin-bottom"
        style="width: 100%"
        :disabled="!domainSelected || !period || isDemo"
        @click.prevent="submit()"
      >
        Да
      </button>
      <button
        class="btn"
        style="width: 100%"
        @click.prevent="hideModal($getConst('DOCUMENTS_ORDER_MODAL_ID'))"
      >
        Нет
      </button>
    </form>
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import apiService from '../../apiService'
import { mapGetters, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied.vue'

/**
 * Модальное окно заказа акта сверки.
 */
export default {
  name: 'DocumentsOrder',
  components: {
    DemoDenied,
    CModalForm
  },
  mixins: [form, modal],
  computed: {
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      period: state => state.seo.forms.documentsOrder.period
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  methods: {
    /**
     * Отправляет данные формы.
     */
    submit () {
      apiService.postFormsDocumentsOrder(this.domainSelected, this.period)
        .then(() => {
          this.hideModal(this.$getConst('DOCUMENTS_ORDER_MODAL_ID'))

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    }
  }
}
</script>
